<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { ENTITIES, OPERATION, USERS_FIELDS } from '@/services/charts-service';
import { calculateVariation } from '@/utils/math';
import { formatSocialNumberWithDecimal } from '@/utils/formatter';

export default {
  name: 'NewFansCompetitive',
  components: {
    SimpleDataWithVariation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    async getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      await this.getChartsService({
        itemId: this.itemId,
        method: 'getDataWithDisplaceRange',
        entity: ENTITIES.USERS,
        points_parser: '',
        params: {
          fields: [USERS_FIELDS.FOLLOWERS],
          grouping: [USERS_FIELDS.UID, USERS_FIELDS.DATE],
          operators: OPERATION.LAST,
        },
      })
        .then(response => {
          this.rawData = response;

          const { currentPeriod, displacedPeriod } = this.rawData;

          const previous = this.getTotalNewFansPerPeriod(displacedPeriod);
          const current = this.getTotalNewFansPerPeriod(currentPeriod);
          const variation = calculateVariation(previous, current);

          const isThereVariation = variation !== undefined;

          this.value = current;
          this.variation = variation;
          this.rawVariation = isThereVariation ? variation : current;
          this.comparationValue = formatSocialNumberWithDecimal(previous);

          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((err) => {
          console.error('err:', err);
          this.requestStatus = 'error';
        });
    },
    getTotalNewFansPerPeriod({ points }) {
      const previousObj = {
        uid: '',
        value: 0,
      };
      const currentObj = {
        uid: '',
        value: 0,
      };

      let periodValue = 0;

      for (let index = 0; index < points.length; index++) {
        const element = points[index];

        const isThereNextData = Boolean(points[index + 1]);
        const hasChangedNextUID = Boolean(previousObj.uid !== points[index + 1]?.coordinates.uid);
        const hasChangedCurrentUID = Boolean(previousObj.uid !== element.coordinates.uid);

        if (hasChangedCurrentUID) {
          previousObj.uid = element.coordinates.uid;
          previousObj.value = element.value;
        } else if (!isThereNextData || hasChangedNextUID) {
          currentObj.uid = element.coordinates.uid;
          currentObj.value = element.value;

          periodValue += currentObj.value - previousObj.value;
        }
      }

      return periodValue;
    },
  },
};
</script>
